import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import React from 'react';

const RichTextDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.richTextWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => (
    <FormatedTextInput
        readonly={!isEditing}
        value={(params.text as string) || ''}
        onChange={(e) => onParamChange(id, 'text', e)}
    />
);

export const richTextDashBoardWidgetDefinition = {
    type: EDashboardWidgetTypes.richTextWidget,
    render: RichTextDashboardWidget,
    overrideCardDesign: false,
    defaultParams: { text: 'Lorem Ipsum' },
} satisfies TWidgetDefinition;
